<template>
    <div class="Serverclaim">
<div style="text-align:center;">
<img src="../assets/images/fyfwsm.png" width="100%">
</div>
<footer style="margin:30px 0;width:100%;">
<mt-button style="width:100%;background-color:#1E70E0;color:white;" @click="backHome">返回首页</mt-button>
    </footer>
    </div>
</template>

<script>
export default {
    name:"Serverclaim",
    methods:{
        backHome(){
            this.$router.push('/');
        }
    }
}
</script>

<style scoped>
.Serverclaim{
    text-align: left;
    color: #585858;
    font-size: 13px;
    padding: 15px 0;
    line-height: 1.5;
}
.Serverclaim p{text-indent: 30px;}
</style>



// WEBPACK FOOTER //
// src/components/Serverclaim.vue